__turbopack_context__.v({
  "className": "bebas_neue_eb0f543-module__0CpguW__className",
  "variable": "bebas_neue_eb0f543-module__0CpguW__variable",
});
